<!--
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-21 13:49:41
 * @LastEditors: Wang Bin <email: binnuo1109@163.com> <tel: 13937670602>
 * @LastEditTime: 2021-07-07 14:49:04
 * @Description: 文本框组件
 * @FilePath: /hsylc2021/src/components/form/Textarea/index.vue
-->
<template>
  <Prototype
    :className="className"
    :placeholder="placeholder"
    :error="error"
    :counter="counter"
    :maxCount="maxCount"
    :value="value"
    :msg="msg"
    :counterReg="counterReg"
    :showMsg="showMsg"
    :disabled="disabled"
    @blur="handleBlur"
    @input="handleInput"
    :height="height"
  >
    <div v-if="isVerific && ((startVerific && isError) || isError)" class="errmsg">{{ errmsgVal }}</div>
  </Prototype>
</template>
<script>
import Prototype from './Prototype';
/**
 * 文本框组件
 * @module Textarea
 */
export default {
  name: 'Textarea',
  components: {
    Prototype
  },
  /**
   * @prop {String} className 组件class名
   * @prop {String} placeholder 水印文本
   * @prop {Boolean} error 是否错误状态 默认false
   * @prop {Boolean} counter 是否展示计数器 默认true
   * @prop {Number} maxCount 计数器最大值展示 默认100
   * @prop {String} value 内容
   * @prop {String} msg 错误信息
   * @prop {Boolean} showMsg 是否展示错误信息 默认true
   * @prop {Boolean} disabled 是否为禁用状态 默认false
   * @prop {String} errmsg 报错信息
   * @prop {Boolean} startVerific 是否一开始开启验证 用户是否选择 默认false
   * @prop {Boolean} isVerific 是否开启验证 用户是否选择 默认true
   */
  props: {
    height: {
      type: String,
      default: '120px'
    },
    className: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '输入框'
    },
    error: {
      type: Boolean,
      default: false
    },
    counter: {
      type: Boolean,
      default: true
    },
    counterReg: {
      type: RegExp
    },
    maxCount: {
      type: Number,
      default: 100
    },
    value: {
      type: String,
      default: ''
    },
    msg: {
      type: String,
      default: ''
    },
    showMsg: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    errmsg: {
      type: String,
      default: '未填写'
    },
    isVerific: {
      type: Boolean,
      default: true
    },
    startVerific: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isError: false, // 是否报错
      errmsgVal: '' // 报错信息
    };
  },
  watch: {
    errmsg(val) {
      this.errmsgVal = val;
    },
    startVerific(val) {
      if (val) this.checkInput();
    },
    error(val) {
      this.isError = val;
    },
    value() {
      // this.checkInput();
      if (this.startVerific) this.checkInput();
    }
  },
  mounted() {
    this.errmsgVal = this.errmsg;
    if (this.startVerific) this.checkInput();
  },
  methods: {
    // 检测 输入框 格式
    checkInput() {
      this.isError = this.value ? false : true;
    },
    /**
     * @event input 输入事件
     * @param {String} value 输入字符串
     */
    /**
     * @description 输入事件
     * @function handleInput
     * @param {Object} e 事件对象
     */
    handleInput: function(value) {
      this.isError = value === '' ? true : false;
      this.$emit('input', value);
    },
    /**
     *  失去焦点
     */
    handleBlur() {
      this.checkInput();
      this.$emit('blur', this.isError, this.id, this.errmsg);
    }
  }
};
</script>
<style lang="less" src="./index.less" scoped></style>
